export default __webpack_public_path__ + "static/media/orla.047bcae9.jpg";